<template>
  <div class="gongchengzizhi">
    <div class="none" id="popular"></div>
    <el-dialog
      customClass="customWidth"
      :visible.sync="dialogVisible"
      :show-close="false"
      :lock-scroll="false"
      :center="true"
      title=""
    >
      <div slot="title" class="dialog-title">
        <div id="watermarkImg">
          <!-- <img ref="watermarkImg" :src="this.imgPath" alt="" /> -->
          <img ref="watermarkImg" :src="imgPath || defaultImg" alt="" />
        </div>
        <h2>{{ this.title }}</h2>
      </div>
      <img
        class="dialog-close"
        src="@/assets/img/case/icon_close@2x.png"
        @click="dialogVisible = false"
      />
    </el-dialog>

    <div class="center-right">
      <h1>资质</h1>
      <p>
        工程资质是指在特定行业领域或工程领域具备的一种资格或资格证书，它表明一个个人、公司或组织具备执行、管理或监督相关工程项目的能力和合法性。工程资质通常需要符合一系列标准和要求，以确保其持有者具备必要的专业知识、技能和经验，能够有效地完成工程项目，同时遵守法律法规和行业标准。
      </p>
      <div class="center-nav">
        <a style="pointer-events:none" href=""
          ><span class="color">资质<i class="bgc bgc2"></i></span
        ></a>
        <span></span>
      </div>

      <ul class="anfanghangyexiehui">
        <li v-for="(person, index) in watermarkedImageList" :key="index">
          <div :class="{ img: person.imgPath, defaultImgBgc: !person.imgPath }">
            <!-- <img
              id="watermarked"
              @click="toggle(index)"
              :src="person.imgPath"
            /> -->
            <img
              @click="toggle(index)"
              :src="person.imgPath || defaultImg"
              alt="图片不存在"
            />
          </div>
          <div class="text">
            <div class="textContent">{{ person.title }}</div>
          </div>
        </li>
      </ul>

      <div
        v-if="!isLoading"
        class="loadingBox"
        v-loading="!isLoading"
        element-loading-text="正在加载中"
      ></div>

      <!-- 分页 -->
      <div v-show="total > 12 && isLoading" class="pagination">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="total"
          :current-change="pageNum"
          @current-change="handleCurrentChange"
          :page-size="12"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// import { removeWatermark, setWaterMark } from "@/utils/watermark";
import { addWatermarkToData } from "@/utils/watermarkAddition";
export default {
  name: "engineering",
  data() {
    return {
      arr: [],
      status: 1,
      type: 3,
      imgPath: "",
      title: "",
      dialogVisible: false,
      total: 0,
      pageNum: 1,
      pageSize: 12,
      originalImages: [], // 存储从接口获取的原始图片数据
      watermarkedImages: [], // 存储带水印的图片地址
      watermarkedImageList: [], //存储所有带水印的图片地址
      isLoading: false,
      defaultImg: require("../../assets/default.png")
    };
  },
  mounted() {
    this.select();
  },
  destroyed() {
    // removeWatermark();
  },

  methods: {
    closeDialog() {
      this.dialogVisible = false;
    },
    getBase64(imgUrl) {
      return new Promise((resolve, reject) => {
        window.URL = window.URL || window.webkitURL;
        // 声明一个XMLHttpRequest
        const xhr = new XMLHttpRequest();
        // 获取图片
        xhr.open("get", imgUrl, true);
        xhr.responseType = "blob";
        xhr.send();
        xhr.onload = function() {
          if (this.status === 200) {
            // 得到一个blob对象
            const blob = this.response;
            const oFileReader = new FileReader();
            oFileReader.onloadend = function(e) {
              const base64 = e.target.result;
              //拿到base64 传出结果
              resolve(base64);
            };
            oFileReader.onerror = function(e) {
              reject();
            };
            oFileReader.readAsDataURL(blob);
          }
        };
      });
    },

    // 水印
    // async addWatermark(imageUrl) {
    //   const canvas = document.createElement("canvas");
    //   const ctx = canvas.getContext("2d");
    //   const image = new Image();
    //   image.src = imageUrl;
    //   image.crossOrigin = "anonymous";

    //   return await new Promise(resolve => {
    //     image.onload = () => {
    //       // 缩小图片尺寸为原来的一半
    //       // const targetWidth = image.width / 2;
    //       // const targetHeight = image.height / 2;

    //       canvas.width = image.width;
    //       canvas.height = image.height;
    //       ctx.drawImage(image, 0, 0);

    //       const watermarkText1 = "昌恩智能";
    //       const watermarkText2 = "www.szce.com";
    //       const fontSize = this.calculateFontSize(canvas.height);

    //       ctx.font = `${fontSize}px 'Microsoft YaHei'`;
    //       // ctx.fillStyle = "#dbdbdb";
    //       ctx.fillStyle = "orange";
    //       ctx.textAlign = "center";
    //       ctx.textBaseline = "middle";

    //       // 旋转角度（以弧度为单位）
    //       const rotationAngle = -6 * (Math.PI / 180);
    //       ctx.rotate(rotationAngle);

    //       // 垂直偏移值
    //       const yOffset = 70;
    //       // console.log(" canvas.width", canvas.width);
    //       // console.log(" canvas.height", canvas.height);

    //       // 判断
    //       if (canvas.width > 2820) {
    //         // 使用嵌套循环绘制水印
    //         for (let row = 0; row < 14; row++) {
    //           for (let col = 0; col < 5; col++) {
    //             ctx.font = "62px 'Microsoft YaHei'";
    //             const x = col * (canvas.width / 5) + canvas.width / 10;
    //             const y =
    //               row * (canvas.height / 14) + canvas.height / 24 + yOffset;
    //             ctx.fillText(watermarkText1, x, y);

    //             const x2 = col * (canvas.width / 5) + canvas.width / 10;
    //             const y2 =
    //               row * (canvas.height / 14) +
    //               (canvas.height / 24) * 1.6 +
    //               yOffset;
    //             ctx.fillText(watermarkText2, x2, y2);
    //           }
    //         }
    //       } else {
    //         // 使用嵌套循环绘制水印
    //         for (let row = 0; row < 16; row++) {
    //           for (let col = 0; col < 4; col++) {
    //             const x = col * (canvas.width / 4) + canvas.width / 10;
    //             const y =
    //               row * (canvas.height / 16) + canvas.height / 24 + yOffset;
    //             ctx.fillText(watermarkText1, x, y);

    //             const x2 = col * (canvas.width / 4) + canvas.width / 10;
    //             const y2 =
    //               row * (canvas.height / 16) +
    //               (canvas.height / 24) * 1.5 +
    //               yOffset;
    //             ctx.fillText(watermarkText2, x2, y2);
    //           }
    //         }
    //       }

    //       // 恢复Canvas的旋转状态
    //       ctx.rotate(-rotationAngle);

    //       const watermarkedImageUrl = canvas.toDataURL("image/jpeg", 0.99);
    //       this.watermarkedImages = watermarkedImageUrl;
    //       resolve(watermarkedImageUrl);
    //     };
    //   });
    // },

    // calculateFontSize(canvasHeight) {
    //   // 根据 canvas 的高度动态计算字体大小
    //   return Math.floor(canvasHeight / 64);
    // },

    async addWatermarkToData2(data) {
      this.watermarkedImageList = [];
      for (const item of data) {
        const imageUrl = item.imgPath;
        const watermarkedImageUrl = await this.addWatermark(imageUrl); // 使用水印方法
        const watermarkedData = {
          imagePath: watermarkedImageUrl,
          resourceId: item.resourceId,
          title: item.title,
          sort: item.sort
        };
        console.log("watermarkedData", watermarkedData);
        this.watermarkedImageList.push(watermarkedData);
      }
      return data;
    },

    async select() {
      try {
        const res = await this.request.get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            category: "资质",
            sort: 1
          }
        });

        this.arr = res.data.data;
        this.total = res.data.total;
        this.originalImages = res.data.data;
        // 调用函数并传入数据数组

        await addWatermarkToData(res.data.data, this);
      } catch (error) {
        console.error("请求数据出错", error);
      }
    },
    // select() {
    //   this.request
    //     .get(`/${this.status}/${this.type}`, {
    //       params: {
    //         pageSize: this.pageSize,
    //         pageNum: this.pageNum,
    //         category: "资质",
    //         sort: 1
    //       }
    //     })
    //     .then(res => {
    //       this.arr = res.data.data;
    //       this.total = res.data.total;
    //       this.originalImages = res.data.data;
    //       this.handlerImg();

    //       console.log("dddddd", this.originalImages);
    //     });
    // },

    handleCurrentChange(pageNum) {
      this.isLoading = false;

      (this.pageNum = pageNum), this.select();
      this.scrollToPosition();
      this.$nextTick(window.scrollBy(0, 50));
    },
    scrollToPosition(position) {
      window.scrollTo({
        top: 400
      });
    },
    toggle(index) {
      console.log("click open dialog");
      if (index >= 0) {
        // this.imgPath = this.arr[index].imgPath;
        this.imgPath = this.watermarkedImageList[index].imgPath;
        this.title = this.arr[index].title;
      }
      this.dialogVisible = true;

      // this.$nextTick(() => {
      //   // 获取元素的宽度和高度
      //   const element = this.$refs.watermarkImg;
      //   const width = element.offsetWidth;
      //   const height = element.offsetHeight;
      //   console.log(`宽度: ${width}px, 高度: ${height}px`);
      //   setWaterMark("临时水印", "www.szce.com", "watermarkImg", width, height);
      // });

      document.body.style.paddingRight = "0px";
    },
    getSimpleText(html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: "<",
        gt: ">",
        nbsp: " ",
        amp: "&",
        quot: '"',
        ldquo: "“",
        mdash: "—",
        rdquo: "”"
      };
      return html
        .replace(re1, "")
        .replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi, function(
          all,
          t
        ) {
          return arrEntities[t];
        });
    }
  }
};
</script>
<style scoped>
.dialog-close {
  position: absolute;
  top: 0;
  right: -56px;
  width: 32px;
  height: 32px;
  cursor: pointer;
}
#watermarkImg {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.dialog-title img {
  padding: 0vw;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 宽度在1200px到1600px之间的PC样式：125%-150% */
@media screen and (min-width: 1200px) and (max-width: 1600px) {
  .center-right {
    width: 1050px !important;
  }
}
/* 宽度在1285 PC样式：150% */
@media screen and (max-width: 1285px) {
  .center-right {
    width: 1010px !important;
  }
}

/* 缩放175% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1199px) {
  .center-right {
    width: 800px !important;
  }
}

/* 缩放200% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1000px) {
  .center-right {
    width: 760px !important;
  }
}

/* @media screen and (max-width: 1285px) and (min-width: 950px) {
  body .center-right {
    width: 100%;
  }
}

@media screen and (max-width: 950px) {
  body .center-right {
    width: 100%;
  }
} */

li {
  width: 102px;
  list-style: none;
  margin-right: 54px;
  cursor: pointer;
}

.center-right {
  float: left;
  /* width: 1138px; */
  width: 1330px;
}

.center-right h1 {
  margin-bottom: 33px;
  font-size: 31px;
  color: #140047;
  line-height: 42px;
  letter-spacing: 1.92px;
}

.center-right .center-nav .color {
  display: block;
  width: 102px;
  color: #140047;
  font-size: 16px;
  line-height: 23px;
}

.center-right .center-nav .bgc {
  background-color: #140047;
}
.bgc2 {
  display: block;
  /* width: 70px !important; */
  width: 34px !important;
  height: 2px;
  background-color: #140047;
}

.center-right .center-nav .active2 a span i {
  background-color: #140047;
}

.center-right p {
  margin-bottom: 33px;
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 29px;
  letter-spacing: 0.96px;
  opacity: 0.72;
}

.center-right .center-nav {
  margin-bottom: 32px;
  display: flex;
  position: relative;
}

.center-right .center-nav a {
  width: 102px;
  height: 48px;
  margin-right: 54px;
  font-size: 20px;
  font-weight: 550;
  color: rgba(0, 0, 0, 0.3);
  line-height: 28px;
  letter-spacing: 0.96px;
  transition: color 0.3s;
}

.center-right .center-nav span i {
  display: block;
  margin-top: 20px;
  width: 100%;
  height: 4px;
  background: transparent;
}

.center-right .center-nav span:nth-child(3) {
  position: absolute;
  top: 44px;
  width: 100%;
  height: 4px;
  background-color: rgba(239, 239, 242, 0.5);
  z-index: -1;
}

.center-right .center-nav a:hover {
  color: #140047;
}

.center-right .center-nav a:hover i {
  background-color: #140047;
}

ul {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
}

.center-right ul li {
  /* width: 265px;
  height: 286px; */
  /* width: 326px; */
  width: 310px;
  height: 352px;
  margin-right: 20px;
  margin-bottom: 40px;
  display: inline-block;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
}

/* .center-right ul li:nth-child(4) {
  margin-right: 0px;
  display: inline-block;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(206, 206, 206, 0.5);
} */

.center-right ul li .img {
  position: relative;
  /* height: 195px; */
  height: 240px;
  background-color: #f1f4fb;
}
.center-right ul li .defaultImgBgc {
  position: relative;
  height: 240px;
  background-color: #010321;
}

.center-right ul li .img img,
.center-right ul li .defaultImgBgc img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 80%;
  object-fit: contain;
}

.center-right ul li .text {
  position: absolute;
  width: 265px;
  /* height: 91px; */
  height: 112px;
  background-color: rgba(255, 255, 255, 0.88);
  font-size: 18px;
  font-weight: 550;

  color: rgba(0, 0, 0, 0.58);
  line-height: 29px;
  letter-spacing: 0.96px;
}

.center-right ul li .text .textContent {
  /* width: 206px; */
  /* height: 59px; */
  /* margin: 16px 42px 16px 16px; */
  width: 310px;
  height: 112px;
  padding: 20px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-align: center;
}

#accc {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
  display: none;
}

#blurr.active {
  pointer-events: none;
  user-select: none;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}

body {
  position: relative;
}

.none {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 975px;
  background-color: bisque;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}

.none .button {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 33px;
}

.none .a {
  position: absolute;
  right: -45px;
  top: -13px;
  display: block;
  width: 26px;
  height: 26px;
  cursor: pointer;
  background: url(../../assets/img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}

.none img {
  width: 910px;
  height: 618px;
}

.none h1 {
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #1d1e20;
  line-height: 25px;
  letter-spacing: 0.9984px;
}

.none p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 28px;
  letter-spacing: 0.9984px;
  padding-bottom: 40px;
}

#popular.active {
  top: 366.0096px;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}

.pagination {
  text-align: center;
  /* padding-bottom: 20px; */
}
.pagination >>> .el-pager .active {
  background-color: #140047 !important;
  color: #fff;
}
.pagination >>> .number,
.pagination >>> .btn-prev,
.pagination >>> .btn-next {
  background-color: #fff !important;
  border-radius: 6px !important;
  border: 1px solid #dddddd;
}
.pagination >>> .el-icon-more {
  background-color: #fff !important;
}
.news-right .pagination {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/qn/engineering.vue